import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const formatVendorSplit = (vendors = [], separator = ", ") =>
  vendors.map((v) => `${v.name} ${v.weight}%`).join(separator);

export const listEmailCategories = async () => {
  try {
    const token = getToken();
    return await apiService.get(API_URL.EMAIL_CATEGORY + "/list", token);
  } catch (err) {
    console.log("Error in listEmailCategories service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const fetchEmailCategories = async (payload) => {
  try {
    const token = getToken();
    return await apiService.post(
      API_URL.EMAIL_CATEGORY + "/fetch",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in fetchEmailCategories service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const createEmailCategory = async (payload) => {
  try {
    const token = getToken();
    return await apiService.post(
      API_URL.EMAIL_CATEGORY + "/create",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in createEmailCategory service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const updateEmailCategory = async (payload) => {
  try {
    const token = getToken();
    return await apiService.put(
      API_URL.EMAIL_CATEGORY + "/update",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in updateEmailCategory service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const deleteEmailCategory = async (id) => {
  try {
    const token = getToken();
    return await apiService.deleteData(
      `${API_URL.EMAIL_CATEGORY}/${id}`,
      token
    );
  } catch (err) {
    console.log("Error in deleteEmailCategory service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};
